import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Attribute, UpdateAttributeRequest } from '@models/attribute.model';
import { environment } from '@environment/environment';
import { mapAttributeToUpdateRequest } from '@modules/shared/services/mappers/attribute.mapper';

@Injectable({providedIn: 'root'})
export class AttributeService {
  private readonly http = inject(HttpClient);
  private readonly ENDPOINT = 'attributes';

  getAll(webshopId: string): Observable<Attribute[]> {
    return this.http.get<Attribute[]>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}`);
  }

  update(request: { webshopId: string, attribute: Partial<Attribute> & { id: string } }): Observable<Attribute> {
    const attribute = mapAttributeToUpdateRequest(request.attribute as Attribute);
    return this.http.patch<Attribute>(`${environment.apiBaseUrl}/webshops/${request.webshopId}/${this.ENDPOINT}/${attribute.id}`, attribute);
  }

  create(request: UpdateAttributeRequest): Observable<Attribute> {
    return this.http.post<Attribute>(`${environment.apiBaseUrl}/webshops/${request.webshopId}/${this.ENDPOINT}`, request.attribute);
  }

  delete(request: { webshopId: string, attributeId: string }): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/webshops/${request.webshopId}/${this.ENDPOINT}/${request.attributeId}`);
  }
}
